import React from 'react'
import { Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors } from '../tokens'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: props => `${props.navWidth}px minmax(0, 1fr)`,
    minHeight: props => props.minHeight,
    background: '#FFFFFF',
    border: `1px solid ${colors.border}`,
    borderRadius: '12px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    padding: '20px 16px',
    borderRight: `1px solid ${colors.border}`,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      overflowX: 'auto',
      borderRight: 0,
      borderBottom: `1px solid ${colors.border}`,
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    height: 40,
    padding: '0 12px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    color: colors.navy,
    '&:hover': {
      background: colors.hover,
    },
  },
  active: {
    background: colors.primarySoft,
    color: colors.primary,
    '&:hover': {
      background: colors.primarySoft,
    },
  },
  icon: {
    width: 18,
    height: 18,
    flex: 'none',
  },
  label: {
    flex: 1,
  },
  trailingWrap: {
    display: 'inline-flex',
  },
  trailing: {
    width: 13,
    height: 13,
    color: colors.subtle,
  },
  content: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px 28px',
  },
}))

/**
 * Card with a vertical nav on the left and the selected section on the
 * right (used by Settings and Share tabs).
 *
 * @param {{ value: string, label: string, icon: string, trailingIcon?: string, trailingHint?: string, badge?: React.ReactNode }[]} items
 */
const SettingsLayout = ({
  items,
  value,
  onChange,
  children,
  navWidth = 260,
  minHeight = 560,
}) => {
  const classes = useStyles({ navWidth, minHeight })

  return (
    <div className={classes.root}>
      <nav className={classes.nav}>
        {items.map(item => (
          <button
            key={item.value}
            type="button"
            className={`${classes.item} ${
              item.value === value ? classes.active : ''
            }`}
            onClick={() => onChange(item.value)}
          >
            <Icon icon={item.icon} className={classes.icon} />
            <span className={classes.label}>{item.label}</span>
            {item.badge}
            {item.trailingIcon &&
              (item.trailingHint ? (
                <Tooltip title={item.trailingHint} placement="right" arrow>
                  <span className={classes.trailingWrap}>
                    <Icon
                      icon={item.trailingIcon}
                      className={classes.trailing}
                    />
                  </span>
                </Tooltip>
              ) : (
                <Icon icon={item.trailingIcon} className={classes.trailing} />
              ))}
          </button>
        ))}
      </nav>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default SettingsLayout
